import { Text } from '@adc/parallax-component-library';

import type { PatientSearchVerifyResponseFound } from '~/api/types';
import { PatientCreateSteps } from '~/features/patientCreation/constants';
import { buildTestId } from '~/utils/buildTestId';

type FoundPatientMessageProps = {
  step: string;
  patient: PatientSearchVerifyResponseFound;
  testID: string;
};

export const FoundPatientMessage = ({
  step,
  patient,
  testID,
}: FoundPatientMessageProps) => {
  if (step === PatientCreateSteps.PATIENT_MULTIPLE_ACCOUNTS_FOUND) {
    return (
      <Text
        type="$bodyBase.default"
        testID={buildTestId({
          testID,
          suffix: ['multiple', 'accounts', 'found'],
        })}
      >
        More than one patient was found matching the email and phone number you
        provided. <br />
        Select your patient below or go back to change your patient contact
        information.
      </Text>
    );
  }

  return (
    <Text
      type="$bodyBase.default"
      testID={buildTestId({
        testID,
        suffix: ['patient', 'found', 'message'],
      })}
    >
      {step === PatientCreateSteps.PATIENT_EMAIL_ACCOUNT_WAS_FOUND ? (
        <>
          A patient with the email address{' '}
          <Text type="$bodyBase.medium">{patient.email}</Text> already exists.
        </>
      ) : (
        <>
          A patient with the phone number{' '}
          <Text type="$bodyBase.medium">{patient.phone}</Text> already exists.
        </>
      )}
      <br />
      Confirm your patient below or go back to change your patient contact
      information.
    </Text>
  );
};
